<div class="application-col application-item-list" *ngIf="reloadHead">
	<!-- <div class="spin-loader" [hidden]="!isLoading"></div> -->
	<div class="spin-loader" *ngIf="isApplicationsLoading"></div>
	<ng-container *ngIf="!isApplicationsLoading">
		<div [ngClass]="{'app_active':appCode===item.code}" class="application-icon" *ngFor="let item of shownList">
			<a class="app_icon_algn" (click)="onClickApplicationItem(item)" title="{{item.label}}">
				<div class="apps-icon {{item.icon}}"></div>
				<span class="purcs_lbl">{{item.label}}</span>
			</a>
		</div>
		<div class="application-selection application-icon dropdown" dropdown *ngIf="hiddenList.length > 0">
			<span class="project-selector dropdown-toggle" dropdownToggle> 
				<i class="fa fa-chevron-down"></i>
			</span>
			<ul *dropdownMenu class="dropdown-menu">
				<li [ngClass]="{'app_dropdown_active':appCode===item.code}" class="" *ngFor='let item of hiddenList'>
					<button  (click)="onClickApplicationItem(item)">
						<div class="apps-icon {{item.icon}}"></div>
						{{item.label}}
					</button>
				</li>
			</ul>
		</div>
	</ng-container>
</div>